module.exports = __webpack_public_path__ + "static/media/IMG_0509_Reduced.64374b2a.jpg";